import { create } from "zustand";

/** Strokes are stored in normalized 0-1 coordinate space so the same
 *  session renders identically on phone, tablet, and desktop. */
export interface Stroke {
  id: string;
  points: { x: number; y: number }[];
  kind: "ink" | "highlight" | "diagram";
}

interface WhiteboardState {
  strokes: Stroke[];
  title: string | null;
  body: string | null;
  highlightedWord: string | null;
  addStroke: (s: Stroke) => void;
  clear: () => void;
  setContent: (content: { title?: string | null; body?: string | null; highlightedWord?: string | null }) => void;
}

export const useWhiteboardStore = create<WhiteboardState>((set) => ({
  strokes: [],
  title: null,
  body: null,
  highlightedWord: null,
  addStroke: (s) => set((state) => ({ strokes: [...state.strokes, s] })),
  clear: () => set({ strokes: [], title: null, body: null, highlightedWord: null }),
  setContent: (content) => set((state) => ({ ...state, ...content })),
}));
